/* eslint-disable eqeqeq */
import { TFunction } from 'react-i18next';
import { map } from 'rxjs/operators';

import { Option } from '../../../../../components/form/elements/select';
import {
  ObservableOptions,
  PagedOptions,
} from '../../../../../components/form/elements/select/async-select';
import Classifier from '../../../../../enums/classifier';
import ClassifierPropertyKey from '../../../../../enums/classifier-property-key'
import ClassifierValue from '../../../../../interfaces/classifierValue';
import Paginate from '../../../../../interfaces/paginate';
import { categoryDataMap } from './async-categories';
import { ClassifierService } from '../../../../../services/classifier.service';
import ClassifierGroup from '../../../../../enums/classifier-group';
import AnimalType from '../../../../../enums/animal-type';

export function typeDataMap(v: ClassifierValue): Option {
  return {
    label: v.value,
    value: v.id,
    veterinary: Object.values(v.properties).find(
      (v) =>
        v.property.key == ClassifierPropertyKey.VETERINARY_MEDICINAL_PRODUCT
    )?.value,
    units: Object.values(v.properties).find(
      (v) => v.property.key == ClassifierPropertyKey.UNITS_OF_MEASURE
    )?.value,
    dry_matter: Object.values(v.properties).find(
      (v) => v.property.key === ClassifierPropertyKey.DRY_MATTER
    )?.value,
    parent: !!v.parent ? categoryDataMap(v.parent) : null,
  };
}

export default function asyncTypes({
  t,
  classifierService,
  eventType,
  defaultValue,
}: {
  t: TFunction;
  classifierService: ClassifierService;
  eventType?: string;
  defaultValue?: string;
}): ObservableOptions {
  return async (
    value,
    loadedOptions,
    { parentName, page, getValues, setValue }
  ): Promise<PagedOptions> => {
    const getName = (name: string) => parentName.concat('.', name);

    const paramsData: any = {
      page,
      value: defaultValue ? defaultValue : value,
      purchased: true,
    };

    const categoryId = getValues(getName('product_category_id'))?.value;

    if (categoryId) {
      paramsData['parent_id'] = categoryId;
    }

    const productTypes = classifierService
      .valuesPaged(
        ClassifierGroup.WAREHOUSE,
        Classifier.PRODUCT_TYPES,
        paramsData
      )
      .pipe(
        map((response: Paginate<ClassifierValue>) => {
          if (!!defaultValue) {
            setValue(parentName.concat('.', 'product_type_id'), {
              label: response.data[0].value,
              value: response.data[0].id,
              veterinary: Object.values(response.data[0].properties).find(
                (v) =>
                  v.property.key ==
                  ClassifierPropertyKey.VETERINARY_MEDICINAL_PRODUCT
              )?.value,
              units: Object.values(response.data[0].properties).find(
                (v) => v.property.key == ClassifierPropertyKey.UNITS_OF_MEASURE
              )?.value,
              dry_matter: Object.values(response.data[0].properties).find(
                (v) => v.property.key === ClassifierPropertyKey.DRY_MATTER
              )?.value,
              parent: categoryDataMap(response.data[0].parent),
            });
          }
          return {
            hasMore: response.last_page > response.current_page,
            options:
              eventType === AnimalType.starter_feed
                ? response.data
                  .map(typeDataMap)
                  .filter((v: any) => Number.isInteger(v.dry_matter))
                : response.data.map(typeDataMap),
            additional: { page: response.current_page + 1 },
          };
        })
      );

    const [types, used] = await Promise.all([productTypes.toPromise(), null]);

    if (used) {
      types.options.unshift(used);
    }

    return types;
  };
}
